const MODERATED_CASTINGS_DATA_REQUEST = 'MODERATED_CASTINGS_DATA_REQUEST';
const MODERATED_CASTINGS_DATA_SUCCESS = 'MODERATED_CASTINGS_DATA_SUCCESS';
const MODERATED_CASTINGS_DATA_FAILURE = 'MODERATED_CASTINGS_DATA_FAILURE';
const MODERATED_CASTINGS_REMOVE_BY_ID = 'MODERATED_CASTINGS_REMOVE_BY_ID';

const ARCHIVE_CASTINGS_DATA_REQUEST = 'ARCHIVE_CASTINGS_DATA_REQUEST';
const ARCHIVE_CASTINGS_DATA_SUCCESS = 'ARCHIVE_CASTINGS_DATA_SUCCESS';
const ARCHIVE_CASTINGS_DATA_FAILURE = 'ARCHIVE_CASTINGS_DATA_FAILURE';
const ARCHIVE_CASTING_REMOVE_BY_ID = 'ARCHIVE_CASTING_REMOVE_BY_ID';

const CASTINGS_DATA_REQUEST = 'CASTINGS_DATA_REQUEST';
const CASTINGS_DATA_SUCCESS = 'CASTINGS_DATA_SUCCESS';
const CASTINGS_DATA_FAILURE = 'CASTINGS_DATA_FAILURE';
const CASTINGS_DATA_ADDED = 'CASTINGS_DATA_ADDED';
const CASTING_STATUS_CHAHNGE_BY_ID = 'CASTING_STATUS_CHAHNGE_BY_ID';
const CASTINGS_REMOVE_BY_ID = 'CASTINGS_REMOVE_BY_ID';

const UPDATE_ALL_CASTINGS = 'UPDATE_ALL_CASTINGS';
const UPDATE_MODERATED_CASTINGS = 'UPDATE_MODERATED_CASTINGS';
const UPDATE_ARCHIVED_CASTINGS = 'UPDATE_ARCHIVED_CASTINGS';
const UPDATE_DECLINED_CASTINGS = 'UPDATE_DECLINED_CASTINGS';

const DELETE_ALL_CASTING_PHOTO = 'DELETE_ALL_CASTING_PHOTO';
const DELETE_MODERATED_CASTING_PHOTO = 'DELETE_MODERATED_CASTING_PHOTO';
const DELETE_ARCHIVED_CASTING_PHOTO = 'DELETE_ARCHIVED_CASTING_PHOTO';

const ADD_CASTING_TO_ALL = 'ADD_CASTING_TO_ALL';
const ADD_CASTING_TO_ARCHIVE_LIST_FROM_ALL = ' ADD_CASTING_TO_ARCHIVE_LIST_FROM_ALL';
const ADD_CASTINGS_TO_DECLINED_LIST = 'ADD_CASTINGS_TO_DECLINED_LIST';
const ADD_CASTING_TO_ARCHIVE_LIST_FROM_DECLINED = 'ADD_CASTING_TO_ARCHIVE_LIST_FROM_DECLINED';

const DECLINED_CASTINGS_DATA_REQUEST = 'DECLINED_CASTINGS_DATA_REQUEST';
const DECLINED_CASTINGS_DATA_SUCCESS = 'DECLINED_CASTINGS_DATA_SUCCESS';
const DECLINED_CASTINGS_DATA_FAILURE = 'DECLINED_CASTINGS_DATA_FAILURE';
const DECLINED_CASTING_REMOVE_BY_ID = 'DECLINED_CASTING_REMOVE_BY_ID ';

const CHANGE_DATA_BY_CASTING_TYPE = 'CHANGE_DATA_BY_CASTING_TYPE';
 
const initialState = {
  allCastings: {
    loading: false,
    success: false,
    failure: false,
    last: false,
    data: null,
  },
  moderatedCastings: {
    loading: false,
    success: false,
    failure: false,
    last: false,
    data: null,
  },
  archivedCastings: {
    loading: false,
    success: false,
    failure: false,
    last: false,
    data: null,
  },
  declinedCastings: {
    loading: false,
    success: false,
    failure: false,
    last: false,
    data: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MODERATED_CASTINGS_DATA_REQUEST:
      return {
        ...state,
        moderatedCastings: {
          loading: true,
          success: false,
          failure: false,
          last: false,
          data: null,
        },
      };
    case MODERATED_CASTINGS_DATA_SUCCESS:
      return {
        ...state,
        moderatedCastings: {
          loading: false,
          success: true,
          failure: false,
          last: action.payload.last,
          data: action.payload.data,
        },
      };
    case MODERATED_CASTINGS_DATA_FAILURE:
      return {
        ...state,
        moderatedCastings: {
          loading: false,
          success: false,
          failure: true,
          last: false,
          data: action.payload,
        },
      };
    case CASTINGS_DATA_REQUEST:
      return {
        ...state,
        allCastings: {
          loading: true,
          success: false,
          failure: false,
          last: false,
          data: null,
        },
      };
    case CASTINGS_DATA_SUCCESS:
      return {
        ...state,
        allCastings: {
          loading: false,
          success: true,
          failure: false,
          last: action.payload.last,
          data: action.payload.data,
        },
      };
    case CASTINGS_DATA_FAILURE:
      return {
        ...state,
        allCastings: {
          loading: false,
          success: false,
          failure: true,
          last: false,
          data: action.payload,
        },
      };
    case CASTING_STATUS_CHAHNGE_BY_ID:
      const newData = [];
      for (let i = 0; i < state.allCastings.data.length; i += 1) {
        if (action.payload.id === state.allCastings.data[i].castingId) {
          newData.push({
            ...state.allCastings.data[i],
            status: action.payload.status,
          });
        } else {
          newData.push(state.allCastings.data[i]);
        }
      }
      return {
        ...state,
        allCastings: {
          ...state.allCastings,
          data: newData,
        },
      };
    case MODERATED_CASTINGS_REMOVE_BY_ID:
      const newListData = [];
      for (let i = 0; i < action.payload.data.length; i += 1) {
        if (action.payload.data[i].castingId !== action.payload.id) {
          newListData.push(action.payload.data[i]);
        }
      }
      return {
        ...state,
        moderatedCastings: {
          ...state.moderatedCastings,
          data: newListData,
        },
      };
    case CASTINGS_DATA_ADDED:
      return {
        ...state,
        [action.payload.key]: {
          loading: false,
          success: true,
          failure: false,
          last: action.payload.last,
          data: action.payload.data,
          direction: action.payload.direction,
          mainCategory: action.payload.mainCategory,
        },
      };
    case ARCHIVE_CASTINGS_DATA_REQUEST:
      return {
        ...state,
        archivedCastings: {
          loading: true,
          success: false,
          failure: false,
          last: false,
          data: null,
        },
      };
    case ARCHIVE_CASTINGS_DATA_SUCCESS:
      return {
        ...state,
        archivedCastings: {
          loading: false,
          success: true,
          failure: false,
          last: action.payload.last,
          data: action.payload.data,
        },
      };
    case ARCHIVE_CASTINGS_DATA_FAILURE:
      return {
        ...state,
        archivedCastings: {
          loading: false,
          success: false,
          failure: true,
          last: false,
          data: action.payload,
        },
      };
    case DECLINED_CASTINGS_DATA_REQUEST:
      return {
        ...state,
        declinedCastings: {
          loading: true,
          success: false,
          failure: false,
          last: false,
          data: null,
        },
      };
    case DECLINED_CASTINGS_DATA_SUCCESS:
      return {
        ...state,
        declinedCastings: {
          loading: false,
          success: true,
          failure: false,
          last: action.payload.last,
          data: action.payload.data,
        },
      };
    case DECLINED_CASTINGS_DATA_FAILURE:
      return {
        ...state,
        declinedCastings: {
          loading: false,
          success: false,
          failure: true,
          last: false,
          data: action.payload,
        },
      };
    case CHANGE_DATA_BY_CASTING_TYPE:
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          ...action.payload.data,
        },
      };
    case UPDATE_ALL_CASTINGS:
      const newAllCastingsList = [];
      for (let i = 0; i < state.allCastings.data.length; i += 1) {
        if (state.allCastings.data[i].castingId === action.payload.id) {
          newAllCastingsList.push({
            ...state.allCastings.data[i],
            title: action.payload.title,
            description: action.payload.description,
          });
        } else {
          newAllCastingsList.push(state.allCastings.data[i]);
        }
      }
      return {
        ...state,
        allCastings: {
          ...state.allCastings,
          data: newAllCastingsList,
        },
      };
    case UPDATE_MODERATED_CASTINGS:
      const newModeratedCastingsList = [];
      for (let i = 0; i < state.moderatedCastings.data.length; i += 1) {
        if (state.moderatedCastings.data[i].castingId === action.payload.id) {
          newModeratedCastingsList.push({
            ...state.moderatedCastings.data[i],
            title: action.payload.title,
            description: action.payload.description,
          });
        } else {
          newModeratedCastingsList.push(state.moderatedCastings.data[i]);
        }
      }
      return {
        ...state,
        moderatedCastings: {
          ...state.moderatedCastings,
          data: newModeratedCastingsList,
        },
      };
    case UPDATE_ARCHIVED_CASTINGS:
      const newArchivedCastingsList = [];
      for (let i = 0; i < state.archivedCastings.data.length; i += 1) {
        if (state.archivedCastings.data[i].castingId === action.payload.id) {
          newArchivedCastingsList.push({
            ...state.archivedCastings.data[i],
            title: action.payload.title,
            description: action.payload.description,
          });
        } else {
          newArchivedCastingsList.push(state.archivedCastings.data[i]);
        }
      }
      return {
        ...state,
        archivedCastings: {
          ...state.archivedCastings,
          data: newArchivedCastingsList,
        },
      };
    case UPDATE_DECLINED_CASTINGS:
      const newDeclinedCastings = [];
      for (let i = 0; i < state.declinedCastings.data.length; i += 1) {
        if (state.declinedCastings.data[i].castingId === action.payload.id) {
          newDeclinedCastings.push({
            ...state.declinedCastings.data[i],
            title: action.payload.title,
            description: action.payload.description,
          });
        } else {
          newDeclinedCastings.push(state.declinedCastings.data[i]);
        }
      }
      return {
        ...state,
        declinedCastings: {
          ...state.declinedCastings,
          data: newDeclinedCastings,
        },
      };
    case DELETE_ALL_CASTING_PHOTO:
      const newAllCastingsListPhotos = [];
      for (let i = 0; i < state.allCastings.data.length; i += 1) {
        if (state.allCastings.data[i].castingId === action.payload.id) {
          newAllCastingsListPhotos.push({
            ...state.allCastings.data[i],
            photos: action.payload.photos,
          });
        } else {
          newAllCastingsListPhotos.push(state.allCastings.data[i]);
        }
      }
      return {
        ...state,
        allCastings: {
          ...state.allCastings,
          data: newAllCastingsListPhotos,
        },
      };
    case DELETE_ARCHIVED_CASTING_PHOTO:
      const newArchivedCastingsListPhotos = [];
      for (let i = 0; i < state.archivedCastings.data.length; i += 1) {
        if (state.archivedCastings.data[i].castingId === action.payload.id) {
          newArchivedCastingsListPhotos.push({
            ...state.archivedCastings.data[i],
            photos: action.payload.photos,
          });
        } else {
          newArchivedCastingsListPhotos.push(state.archivedCastings.data[i]);
        }
      }
      return {
        ...state,
        archivedCastings: {
          ...state.archivedCastings,
          data: newArchivedCastingsListPhotos,
        },
      };
    case DELETE_MODERATED_CASTING_PHOTO:
      const newModeratedCastingsListPhotos = [];
      for (let i = 0; i < state.moderatedCastings.data.length; i += 1) {
        if (state.moderatedCastings.data[i].castingId === action.payload.id) {
          newModeratedCastingsListPhotos.push({
            ...state.moderatedCastings.data[i],
            photos: action.payload.photos,
          });
        } else {
          newModeratedCastingsListPhotos.push(state.moderatedCastings.data[i]);
        }
      }
      return {
        ...state,
        moderatedCastings: {
          ...state.moderatedCastings,
          data: newModeratedCastingsListPhotos,
        },
      };
    case ARCHIVE_CASTING_REMOVE_BY_ID:
      const newArchivedCastings = [];
      for (let i = 0; i < state.archivedCastings.data.length; i += 1) {
        if (state.archivedCastings.data[i].castingId !== action.payload.id) {
          newArchivedCastings.push(state.archivedCastings.data[i]);
        }
      }
      return {
        ...state,
        archivedCastings: {
          ...state.archivedCastings,
          data: newArchivedCastings,
        },
      };
    case CASTINGS_REMOVE_BY_ID:
      const newAllCastings = [];
      for (let i = 0; i < state.allCastings.data.length; i += 1) {
        if (action.payload.id !== state.allCastings.data[i].castingId) {
          newAllCastings.push(state.allCastings.data[i]);
        }
      }
      return {
        ...state,
        allCastings: {
          ...state.allCastings,
          data: newAllCastings,
        },
      };
    case ADD_CASTING_TO_ARCHIVE_LIST_FROM_ALL:
      let newArchiveCastingsAfterAdding;
      for (let i = 0; i < state.allCastings.data.length; i += 1) {
        if (action.payload.id === state.allCastings.data[i].castingId) {
          newArchiveCastingsAfterAdding = state.allCastings.data[i];
        }
      }
      return {
        ...state,
        archivedCastings: {
          ...state.archivedCastings,
          data: [{ ...newArchiveCastingsAfterAdding, status: 'archive' }, ...state.archivedCastings.data],
        },
      };
    case ADD_CASTING_TO_ARCHIVE_LIST_FROM_DECLINED:
      let newArchiveCastingsAfterAddingDeclined;
      for (let i = 0; i < state.declinedCastings.data.length; i += 1) {
        if (action.payload.id === state.declinedCastings.data[i].castingId) {
          newArchiveCastingsAfterAddingDeclined = state.declinedCastings.data[i];
        }
      }
      return {
        ...state,
        archivedCastings: {
          ...state.archivedCastings,
          data: [{ ...newArchiveCastingsAfterAddingDeclined, status: 'archive' }, ...state.archivedCastings.data],
        },
      };
    case ADD_CASTING_TO_ALL:
      let newAllCastingAfterAdding;
      for (let i = 0; i < state.archivedCastings.data.length; i += 1) {
        if (action.payload.id === state.archivedCastings.data[i].castingId) {
          newAllCastingAfterAdding = state.archivedCastings.data[i];
        }
      }
      return {
        ...state,
        allCastings: {
          ...state.allCastings,
          data: [{ ...newAllCastingAfterAdding, status: 'accept' }, ...state.allCastings.data],
        },
      };
    case ADD_CASTINGS_TO_DECLINED_LIST:
      let newDeclinedCastingsAfterAdding;
      for (let i = 0; i < state.allCastings.data.length; i += 1) {
        if (action.payload.id === state.allCastings.data[i].castingId) {
          newDeclinedCastingsAfterAdding = state.allCastings.data[i];
        }
      }
      return {
        ...state,
        declinedCastings: {
          ...state.declinedCastings,
          data: [{ ...newDeclinedCastingsAfterAdding, status: 'decline' }, ...state.declinedCastings.data],
        },
      };
    case DECLINED_CASTING_REMOVE_BY_ID:
      const newDeclinedCastingsData = [];
      for (let i = 0; i < state.declinedCastings.data.length; i += 1) {
        if (state.declinedCastings.data[i].castingId !== action.payload.id) {
          newDeclinedCastingsData.push(state.declinedCastings.data[i]);
        }
      }
      return {
        ...state,
        declinedCastings: {
          ...state.declinedCastings,
          data: newDeclinedCastingsData,
        },
      };
    default:
      return state;
  }
};

export default reducer;

/**
 * Actions
 */

export const moderatedСastingsDataRequest = () => ({
  type: MODERATED_CASTINGS_DATA_REQUEST,
});

export const moderatedСastingsDataSuccess = (payload) => ({
  type: MODERATED_CASTINGS_DATA_SUCCESS,
  payload,
});

export const moderatedСastingsDataFailure = (payload) => ({
  type: MODERATED_CASTINGS_DATA_FAILURE,
  payload,
});

export const castingChangeStatusById = (payload) => ({
  type: CASTING_STATUS_CHAHNGE_BY_ID,
  payload,
});

export const moderatedCastingsRemoveById = (payload) => ({
  type: MODERATED_CASTINGS_REMOVE_BY_ID,
  payload,
});

export const castingsDataRequest = () => ({
  type: CASTINGS_DATA_REQUEST,
});

export const castingsDataSuccess = (payload) => ({
  type: CASTINGS_DATA_SUCCESS,
  payload,
});

export const castingsDataFailure = (payload) => ({
  type: CASTINGS_DATA_FAILURE,
  payload,
});

export const castingsDataAdded = (payload) => ({
  type: CASTINGS_DATA_ADDED,
  payload,
});

export const archivedCastingsDataRequest = () => ({
  type: ARCHIVE_CASTINGS_DATA_REQUEST,
});

export const archivedCastingsDataSuccess = (payload) => ({
  type: ARCHIVE_CASTINGS_DATA_SUCCESS,
  payload,
});

export const archivedCastingsDataFailure = (payload) => ({
  type: ARCHIVE_CASTINGS_DATA_FAILURE,
  payload,
});

export const declinedCastingsDataRequest = () => ({
  type: DECLINED_CASTINGS_DATA_REQUEST,
});

export const declinedCastingsDataSuccess = (payload) => ({
  type: DECLINED_CASTINGS_DATA_SUCCESS,
  payload,
});

export const declinedCastingsDataFailure = (payload) => ({
  type: DECLINED_CASTINGS_DATA_FAILURE,
  payload,
});

export const changeDataByCastingType = (payload) => ({
  type: CHANGE_DATA_BY_CASTING_TYPE,
  payload,
});

export const updateAllCastings = (payload) => ({
  type: UPDATE_ALL_CASTINGS,
  payload,
});

export const updateModeratedCastings = (payload) => ({
  type: UPDATE_MODERATED_CASTINGS,
  payload,
});

export const updateArchivedCastings = (payload) => ({
  type: UPDATE_ARCHIVED_CASTINGS,
  payload,
});

export const updateDeclinedCastings = (payload) => ({
  type: UPDATE_DECLINED_CASTINGS,
  payload,
});

export const deleteAllCastingPhoto = (payload) => ({
  type: DELETE_ALL_CASTING_PHOTO,
  payload,
});

export const deleteModeratedCastingPhoto = (payload) => ({
  type: DELETE_MODERATED_CASTING_PHOTO,
  payload,
});

export const deleteArchivedCastingPhoto = (payload) => ({
  type: DELETE_ARCHIVED_CASTING_PHOTO,
  payload,
});

export const allCastingRemoveById = (payload) => ({
  type: CASTINGS_REMOVE_BY_ID,
  payload,
});

export const archiveCastingRemoveById = (payload) => ({
  type: ARCHIVE_CASTING_REMOVE_BY_ID,
  payload,
});

export const addCastingToArchiveListFromAll = (payload) => ({
  type: ADD_CASTING_TO_ARCHIVE_LIST_FROM_ALL,
  payload,
});

export const addCastingToArchiveListFromDeclined = (payload) => ({
  type: ADD_CASTING_TO_ARCHIVE_LIST_FROM_DECLINED,
  payload,
});

export const addCastingToAll = (payload) => ({
  type: ADD_CASTING_TO_ALL,
  payload,
});

export const addCastingToDeclinedList = (payload) => ({
  type: ADD_CASTINGS_TO_DECLINED_LIST,
  payload,
});

export const declinedCastingRemoveById = (payload) => ({
  type: DECLINED_CASTING_REMOVE_BY_ID,
  payload,
});
